import { Injectable } from '@angular/core'
import { $app } from '@app/app.service'
import { InnplaceList } from '@app/data/model/innplaceList.model'
import { InnplaceService } from '@app/data/service/innplace.service'
import { AppNotificationService } from '@core/app-notification.service'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { select, Store } from '@ngrx/store'
import { NotificationType } from 'angular2-notifications'
import { of } from 'rxjs'
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators'
import { AppState } from '../storage.module'
import * as StageActions from './stage.actions'
import { selectMenuOpen } from './stage.selectors'

@Injectable()
export class StageEffects {
   toggleMenu$ = createEffect(() =>
      this.actions$.pipe(
         ofType(StageActions.toggleMenu),
         withLatestFrom(this.store.pipe(select(selectMenuOpen))),
         switchMap(([action, isMenuOpen]) => {
            return of(isMenuOpen ? StageActions.closeMenu() : StageActions.openMenu())
         })
      )
   )

   loadInnplaceLists$ = createEffect(() =>
      this.actions$.pipe(
         ofType(StageActions.loadInnplaceLists),
         switchMap(() =>
            this.innplaceSrv.getAllLists().pipe(
               map((res: InnplaceList) => StageActions.loadInnplaceListsSuccess({ innplaceList: res })),
               catchError((error) => of(StageActions.loadInnplaceListsFailed({ error })))
            )
         )
      )
   )

   constructor(
      private store: Store<AppState>,
      private actions$: Actions,
      private innplaceSrv: InnplaceService,
      private notifyService: AppNotificationService
   ) {}

   private _actionsForSpinnerHide = [StageActions.loadInnplaceListsSuccess, StageActions.loadInnplaceListsFailed]

   listenAllSpinnerHideAction$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(...this._actionsForSpinnerHide),
            map(() => $app.core.spinnerHide())
         ),
      { dispatch: false }
   )

   private _actionsForSpinnerShow = [StageActions.loadInnplaceLists]

   listenAllSpinnerShowAction$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(...this._actionsForSpinnerShow),
            map(() => $app.core.spinnerShow())
         ),
      { dispatch: false }
   )

   private _actionsFailedNotification = [StageActions.loadInnplaceListsFailed]

   listenAllFailedAction$ = createEffect(
      () =>
         this.actions$.pipe(
            ofType(...this._actionsFailedNotification),
            map((errorResponse) =>
               this.notifyService.notify(NotificationType.Error, undefined, `${errorResponse.error.status} - ${errorResponse.error.statusText}`)
            )
         ),
      { dispatch: false }
   )
}

